export default function removeClasses() {
  var swiper = this;
  var $el = swiper.$el,
      classNames = swiper.classNames;
  $el.removeClass(classNames.join(' '));
  swiper.emitContainerClasses();
}


//////////////////
// WEBPACK FOOTER
// ./~/swiper/esm/components/core/classes/removeClasses.js
// module id = 711
// module chunks = 169